const CompanyHero = () => {
  return (
    <section className="relative min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image – echtes Foto von gowitec.de */}
      <div className="absolute inset-0">
        <img
          src="/images/oben1.jpg"
          alt="gowiTEC Unternehmen – Automatisierungstechnik seit 1992"
          className="w-full h-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f4a]/80 via-[#0f1f4a]/70 to-[#0f1f4a]/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 text-center">
        <span className="inline-block text-[#DC2626] text-xs font-semibold tracking-widest uppercase mb-4">
          Über uns
        </span>
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
          Technik mit Leidenschaft –<br className="hidden md:block" /> seit 1992
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          gowiTEC entwickelt und realisiert individuelle Lösungen für Maschinenbau, SPS und Automation –
          inhabergeführt, praxisnah und mit über 30 Jahren Erfahrung.
        </p>
      </div>
    </section>
  );
};

export default CompanyHero;
